import { TriangleAlert } from 'lucide-react';
import React, { FC, ReactNode } from 'react';

import { Flex } from '../Flex';
import {
  ActionBlockContainer,
  ActionBlockDescription,
  ActionBlockFooter,
  ActionBlockInfo,
  ActionBlockTitle,
  ActionBlockWrapper,
  HeaderWrapper,
  WarningBlockWrapper,
} from './ActionBlock.styled';

interface ActionBlock {
    children?: ReactNode;
    maxWidth?: string;
    title?: ReactNode;
    description?: ReactNode;
    footer?: ReactNode;
    isTransparent?: boolean;
    id?: string;
    action?: ReactNode;
    variantDanger?: boolean;
    showAlert?: boolean;
}

interface WarningBlockProps {
    children: ReactNode;
}

export const WarningBlock: FC<WarningBlockProps> = ({ children }) => (
  <WarningBlockWrapper>
    <TriangleAlert size={18} />
    {children}
  </WarningBlockWrapper>
);

export const ActionBlock:FC<ActionBlock> = ({
  children,
  maxWidth,
  title,
  description,
  footer,
  isTransparent,
  id,
  action,
  variantDanger,
  showAlert,
}) => (
  <Flex itemAlign="flex-start" gap="0">
    {showAlert
          && (
          <WarningBlock>
            <p>
              Uwaga te dane nie są automatycznie tłumaczone , zalecamy używanie prostych form i danych
            </p>
          </WarningBlock>
          )}
    <ActionBlockWrapper
      maxWidth={maxWidth}
      isTransparent={isTransparent}
      id={id}
      isDanger={variantDanger}
      className="flex rounded-sm shadow-sm "
    >

      <ActionBlockContainer>
        {(title || description) && (
          <ActionBlockInfo>
            <HeaderWrapper>
              <ActionBlockTitle>{title}</ActionBlockTitle>
              {action && <div>{action}</div>}
            </HeaderWrapper>
              {description && (
              <ActionBlockDescription>
                {description}
              </ActionBlockDescription>
              )}
          </ActionBlockInfo>
        )}
        <div>{children}</div>
      </ActionBlockContainer>
      {footer && (
        <ActionBlockFooter>
          {footer}
        </ActionBlockFooter>
      )}
    </ActionBlockWrapper>

  </Flex>
);
